// Legit custom: Quick add size buttons on product cards submit Prestige's own product form,
// so the cart drawer refreshes and opens natively.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-legit-quick-toggle]');

  if (toggle) {
    toggle.closest('.lg-pcard')?.classList.toggle('is-quick-open');
    toggle.textContent = toggle.closest('.lg-pcard')?.classList.contains('is-quick-open') ? '×' : '+';
    return;
  }

  const button = event.target.closest('[data-legit-quick-size]');

  if (!button || button.disabled) {
    return;
  }

  const form = button.closest('form');
  form.querySelector('input[name="id"]').value = button.dataset.legitQuickSize;
  button.setAttribute('aria-busy', 'true');
  form.requestSubmit();

  setTimeout(() => {
    button.removeAttribute('aria-busy');
    const card = button.closest('.lg-pcard');
    card?.classList.remove('is-quick-open');
    const toggle = card?.querySelector('[data-legit-quick-toggle]');
    if (toggle) toggle.textContent = '+';
  }, 1200);
});

// Legit (ported from FOOLSGOLD): size chart cm / in toggle.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-fg-unit]');
  if (!button) return;
  const box = button.closest('[data-fg-size]');
  const unit = button.dataset.fgUnit;
  box.querySelectorAll('[data-fg-unit]').forEach((item) => {
    const on = item === button;
    item.classList.toggle('is-active', on);
    item.setAttribute('aria-pressed', String(on));
  });
  box.querySelectorAll('[data-cm]').forEach((item) => { item.hidden = unit !== 'cm'; });
  box.querySelectorAll('[data-in]').forEach((item) => { item.hidden = unit !== 'in'; });
});

// Legit (ported from FOOLSGOLD): size select in the sticky add-to-bag bar. It is built from the main size picker
// and selects the matching size there, so Prestige updates the variant, price and button everywhere.
(() => {
  const build = (bar) => {
    const formId = bar.getAttribute('form');
    const title = bar.querySelector('.product-sticky-bar__info .h6');
    if (title && !title.classList.contains('lg-sticky__title')) {
      title.classList.add('lg-sticky__title');
      title.textContent = title.textContent.replace(/ - /g, ' — ');
    }
    if (!formId || bar.querySelector('[data-lg-sticky-select]')) return;

    let option = null;
    document.querySelectorAll('.shopify-section--main-product .variant-picker__option').forEach((fieldset) => {
      const radios = fieldset.querySelectorAll(`input[type="radio"][form="${formId}"]`);
      if (!option && radios.length > 1) option = { fieldset, radios };
    });
    if (!option) return;

    const select = document.createElement('select');
    select.className = 'lg-sticky__select';
    select.setAttribute('data-lg-sticky-select', '');
    const legend = option.fieldset.querySelector('legend');
    select.setAttribute('aria-label', legend ? legend.textContent.trim() : 'Size');

    option.radios.forEach((radio) => {
      const label = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      const name = (label ? label.textContent : radio.value).trim();
      const soldOut = label && label.classList.contains('is-disabled');
      const opt = document.createElement('option');
      opt.value = radio.id;
      opt.textContent = soldOut ? `${name} — sold out` : name;
      opt.selected = radio.checked;
      select.appendChild(opt);
    });

    select.addEventListener('change', () => {
      const radio = document.getElementById(select.value);
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const buttons = bar.querySelector(':scope > buy-buttons');
    if (buttons) bar.insertBefore(select, buttons); else bar.appendChild(select);
  };

  const run = () => document.querySelectorAll('product-sticky-bar').forEach(build);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
